import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import dayjs from "dayjs";
import { DatePicker } from "antd";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import FullCalendar from "@fullcalendar/react";
import Calendar from "@fullcalendar/react";
import Swal from "sweetalert2";
import useApi from "../../../core/customhook/useApi";
import { employee_email } from "../../../environment";
import Loader from "../../../core/common/selfLoder";

const OutdutyApplicationTeamMamber = () => {
  const navigate = useNavigate();
  const Location = useLocation();
  const calendarRef = useRef<Calendar | null>(null);
  const searchValue = Location.state?.searchValue?.employee_name || "";
  const employee_id = Location.state?.searchValue?.employee_id || "";

  const formatFinancialYear = (year: number) => {
    const nextYearShort = (year + 1).toString().slice(-2);
    return `${year}-${nextYearShort}`;
  };

  const getFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    return formatFinancialYear(year);
  };

  const [finance_year, setFinance_year] = useState(getFinancialYear());

  const {
    data: od_slice_type,
    loading: od_slice_type_loading,
    error: od_slice_type_error,
  } = useApi("/api/master/get-leave-slice-type", {
    method: "GET",
    autoCall: true,
  });

  const {
    data: od_details,
    loading: od_details_loading,
    error: od_details_error,
  } = useApi("/api/manager/view-od-summary", {
    method: "POST",
    payload: {
      employee_id: employee_id,
      financial_year: finance_year
    },
    autoCall: true,
  });

  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body;
  };

  useEffect(() => {
    const handleShown = () => {
      if (calendarRef.current) {
        requestAnimationFrame(() => {
          const calendarApi = calendarRef.current!.getApi();
          calendarApi.updateSize();
        });
      }
    };

    const modalElement = document.getElementById("exampleModalLg");
    if (modalElement) {
      modalElement.addEventListener("shown.bs.modal", handleShown);
    }

    return () => {
      if (modalElement) {
        modalElement.removeEventListener("shown.bs.modal", handleShown);
      }
    };
  }, []);

  const [data, setData] = useState({
    apply_date: new Date().toISOString().split("T")[0],
    employee_id: employee_id,
    od_type: "",
    from_date: "",
    to_date: "",
    od_slice_id: "",
    reason: "",
    manager_email: employee_email,
    cc_email: "",
  });

  const getInputData = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    if (name === "od_slice_id") {
      setData((prev) => ({
        ...prev,
        [name]: value,
        to_date: prev.to_date ? "" : prev.to_date,
      }));
    }
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const {
    data: submitResponse,
    loading: submitLoading,
    error: submitError,
    callApi: submitLeaveRequest,
  } = useApi("/api/manager/team-od-application", {
    method: "POST",
    autoCall: false,
  });

  const postData = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const response = await submitLeaveRequest(data, undefined);
      console.log(response);
      if ((response.statusCode = 201)) {
        Swal.fire({
          title: "Success!",
          text: response?.message || "OD application submitted successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
        navigate("/out-duty-team-status");
      }
    } catch (error: any) {
      console.error("Submission failed:", error);
      Swal.fire({
        title: "Error!",
        text:
          error?.response?.data?.message ||
          "Failed to submit leave application. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <>
      <Loader loading={od_slice_type_loading || submitLoading} />
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-2">
            <div className="my-auto mb-2">
              <h2 className="mb-2">Out Duty</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Leave Coordinator</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Out Duty
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <div>
                <Link
                  to="/out-duty-team-member"
                  className="btn btn-primary py-1 px-3"
                >
                  Back
                </Link>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-9">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={postData}>
                    {/* Application Plan */}
                    <div className="d-flex gap-2 justify-content-center align-items-center">
                      <h4
                        className=" text-white p-2 mb-4 rounded"
                        style={{ backgroundColor: "#2e3294", width: "100%" }}
                      >
                        Application : {searchValue}
                      </h4>
                      {/* <span
                        className="bi bi-calendar-fill  mb-4"
                        style={{ fontSize: "30px", cursor: "pointer" }}
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModalLg"
                      ></span> */}
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label">
                          <strong>Apply Date</strong>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="apply_date"
                          value={new Date().toISOString().split("T")[0]}
                          readOnly
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">
                          <strong>
                            Type<sup className="text-danger">*</sup>
                          </strong>
                        </label>
                        <select
                          className="form-select"
                          required
                          name="od_type"
                          onChange={getInputData}
                        >
                          <option value="">Select Type</option>
                          <option value="Out Duty">Out Duty</option>
                        </select>
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">
                        <strong>OD Slice</strong>
                      </label>
                      <div className="d-flex gap-4 flex-wrap">
                        {od_slice_type?.data.map((item: any, index: number) => (
                          <div className="form-check" key={index}>
                            <input
                              className="form-check-input"
                              type="radio"
                              name="od_slice_id"
                              id={`half${index}`}
                              value={item?.leave_slice_id}
                              onChange={getInputData}
                              required
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`half${index}`}
                            >
                              {item?.slice_type}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label">
                          <strong>
                            Date From<sup className="text-danger">*</sup>
                          </strong>
                        </label>
                        <div className="input-icon-end position-relative">
                          <DatePicker
                            className="form-control datetimepicker"
                            format={{ format: "DD-MM-YYYY", type: "mask" }}
                            getPopupContainer={getModalContainer}
                            placeholder="DD-MM-YYYY"
                            name="from_date"
                            required
                            value={
                              data.from_date
                                ? dayjs(data.from_date, "YYYY-MM-DD")
                                : null
                            }
                            onChange={(date) => {
                              const newFromDate = date
                                ? date.format("YYYY-MM-DD")
                                : "";

                              setData((prev) => {
                                const currentToDate = dayjs(
                                  prev.to_date,
                                  "YYYY-MM-DD"
                                );

                                // Clear `to_date` if it's before the newly selected `from_date`
                                const shouldClearToDate =
                                  prev.to_date &&
                                  date &&
                                  currentToDate.isBefore(date, "day");

                                return {
                                  ...prev,
                                  from_date: newFromDate,
                                  to_date: shouldClearToDate
                                    ? ""
                                    : prev.to_date,
                                };
                              });
                            }}

                          />
                          <span className="input-icon-addon">
                            <i className="ti ti-calendar text-gray-7" />
                          </span>
                        </div>
                      </div>

                      {data?.od_slice_id === "1" ? (
                        <div className="col-md-6">
                          <label className="form-label">
                            <strong>
                              Date To<sup className="text-danger">*</sup>
                            </strong>
                          </label>
                          <div className="input-icon-end position-relative">
                            <DatePicker
                              className="form-control datetimepicker"
                              format={{ format: "DD-MM-YYYY", type: "mask" }}
                              getPopupContainer={getModalContainer}
                              placeholder="DD-MM-YYYY"
                              name="to_date"
                              required
                              value={
                                data.to_date
                                  ? dayjs(data.to_date, "YYYY-MM-DD")
                                  : null
                              }
                              onChange={(date) =>
                                setData((prev) => ({
                                  ...prev,
                                  to_date: date
                                    ? date.format("YYYY-MM-DD")
                                    : "",
                                }))
                              }
                              disabledDate={(current: any) => {
                                const fromDate = dayjs(
                                  data.from_date,
                                  "YYYY-MM-DD"
                                );
                                return current && current.isBefore(fromDate, "day");
                              }}
                            />
                            <span className="input-icon-addon">
                              <i className="ti ti-calendar text-gray-7" />
                            </span>
                          </div>
                        </div>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <label className="form-label">
                        <strong>
                          Reason<sup className="text-danger">*</sup>
                        </strong>
                      </label>
                      <textarea
                        className="form-control"
                        rows={3}
                        required
                        placeholder="Enter reason for leave"
                        name="reason"
                        onChange={getInputData}
                      ></textarea>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label">
                          <strong>
                            Manager Email<sup className="text-danger">*</sup>
                          </strong>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          value={data?.manager_email || ""}
                          required
                          name="manager_email"
                          readOnly
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">
                          <strong>CC Mail (Optional)</strong>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Enter CC email"
                          name="cc_email"
                          onChange={getInputData}
                        />
                      </div>
                    </div>

                    {/* Submit Button */}
                    <div className="d-flex justify-content-center mt-4">
                      <button type="submit" className="btn btn-primary btn-lg">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div
                className="stickybar"
                style={{ position: "sticky", top: "60px", zIndex: 100 }}
              >
                <div className="card">
                  <div className="card-body p-3">
                    <table className="table table-bordered mb-0">
                      <thead>
                        <tr>
                          <th colSpan={2} className="text-center bg-light">
                            Out Duty for {finance_year.split("-")[0]}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th>Total Applied</th>
                          <td>{od_details?.data.total_applied_od || 0}</td>
                        </tr>
                        <tr>
                          <th>Total Approved</th>
                          <td>{od_details?.data.approved_od || 0}</td>
                        </tr>
                        <tr>
                          <th>Pending for Approval</th>
                          <td>{od_details?.data.pending_od || 0}</td>
                        </tr>
                        <tr>
                          <th>Rejected</th>
                          <td>{od_details?.data.rejected_od || 0}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModalLg"
        tabIndex={-1}
        aria-labelledby="exampleModalLgLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLgLabel">
                Attendance Calendar
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <FullCalendar
                ref={calendarRef}
                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                initialView="dayGridMonth"
                headerToolbar={{
                  start: "today,prev,next",
                  center: "title",
                  end: "dayGridMonth,dayGridWeek,dayGridDay",
                }}
                height={500}
              />
              <div className="py-3">
                <div className="card">
                  <div className="card-body">
                    {/* <h6 className="mb-2">
                         <strong>Attendance Legend</strong>
                       </h6> */}
                    <div className="row">
                      <div className="col-md-6">
                        <ul className="list-unstyled mb-2">
                          <li>
                            <strong
                              style={{
                                display: "inline-block",
                                width: "16px",
                                height: "16px",
                                backgroundColor: "#00D3CF", // Weekly Off
                                marginRight: "8px",
                              }}
                            ></strong>
                            Weekly Off
                          </li>
                          <li>
                            <strong
                              style={{
                                display: "inline-block",
                                width: "16px",
                                height: "16px",
                                backgroundColor: "#FF0000", // Absent
                                marginRight: "8px",
                              }}
                            ></strong>
                            Absent
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-6">
                        <ul className="list-unstyled mb-2">
                          <li>
                            <strong
                              style={{
                                display: "inline-block",
                                width: "16px",
                                height: "16px",
                                backgroundColor: "#000000", // Disapprove
                                marginRight: "8px",
                              }}
                            ></strong>
                            Disapprove
                          </li>
                          <li>
                            <strong
                              style={{
                                display: "inline-block",
                                width: "16px",
                                height: "16px",
                                backgroundColor: "#FFFF00", // Pending
                                marginRight: "8px",
                                border: "1px solid #ccc",
                              }}
                            ></strong>
                            Pending
                          </li>
                          <li>
                            <strong
                              style={{
                                display: "inline-block",
                                width: "16px",
                                height: "16px",
                                backgroundColor: "lightblue", // Approved
                                marginRight: "8px",
                              }}
                            ></strong>
                            Approved
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OutdutyApplicationTeamMamber;
